module.exports = __webpack_public_path__ + "static/media/bin-grey.f9424bf2.svg";